const LIST_QUERY = `
  query ListWebhooks($paginationParams: PaginationInput!) {
    listWebHooks (pagination: $paginationParams) {
      objects {
        name
        uuid
        type
        url
        isActive
      }
      totalRows
    }
  }
`

const CREATE_MUTATION = `
  mutation CreateWebhook(
    $name: String!,
    $type: WebHookType!,
    $url: String!
    $description: String
    $isActive: Boolean) {
    createWebHook (params: {
      name: $name,
      type: $type,
      url: $url,
      description: $description,
      isActive: $isActive
    }) {
      uuid
    }
  }
`

const UPDATE_MUTATION = `
  mutation UpdateWebhook(
    $type: WebHookType!,
    $uuid: String!
    $name: String!,
    $url: String!
    $isActive: Boolean) {
    updateWebHook (params: {
      uuid: $uuid,
      name: $name,
      url: $url,
      isActive: $isActive,
      type: $type,
    }) {
      uuid
      isActive
    }
  }
`

const DELETE_MUTATION = `
  mutation DeleteWebHook($uuid: String!) {
    deleteWebHook(uuid: $uuid)
  }
`

const TEST_MUTATION = `
  mutation TestWebHook($uuid: String!) {
    testWebHook(uuid: $uuid)
  }
`

const webhookQueries = {
  methods: {
    async listWebhooksQuery(paginationParams) {
      try {
        const _result = await this.graphQuery(LIST_QUERY, {paginationParams})
        return _result.listWebHooks.objects
      } catch (error) {
        throw new Error(error)
      }
    },
    async createWebhookMutation(webhook) {
      try {
        const _result = await this.graphQuery(CREATE_MUTATION, webhook)
        return _result.createWebHook
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateWebhookMutation(webhook) {
      try {
        const _result = await this.graphQuery(UPDATE_MUTATION, webhook)
        return _result.updateWebHook
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteWebhookMutation(webhook) {
      try {
        const _result = await this.graphQuery(DELETE_MUTATION, webhook)
        return _result.deleteWebHook
      } catch (error) {
        throw new Error(error)
      }
    },
    async testWebhookMutation(webhook) {
      try {
        const _result = await this.graphQuery(TEST_MUTATION, webhook)
        return _result.testWebHook
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default webhookQueries
